(function ($) {
	$.fn.lmPrint = function(options) {
		// NOTE: Don't run logic below if nothing is in the dom
		if (!this.length) {
			return false;
		}
		
		// These are all the methods available for the plugin
		var methods = {};

		methods.events = function($context) {
			$context.off('click.lmPrint').on('click.lmPrint', function(evt) {
				evt.preventDefault();
				window.print();
			});
		}
		
		// Run once methods when jquery plugin is called
		methods.events(this);
};

}(jQuery));
